import { render, staticRenderFns } from "./purchase-history.vue?vue&type=template&id=fd2c39dc&scoped=true&"
import script from "./purchase-history.vue?vue&type=script&lang=js&"
export * from "./purchase-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2c39dc",
  null
  
)

export default component.exports